module.exports = __webpack_public_path__ + "img/Botany.1a673ef5.svg";